<div class="core-ui-message-composer" [class.is-disabled]="disabled" [class.is-readonly]="readOnly">
  <div class="core-ui-message-composer__shell">
    <div class="core-ui-message-composer__toolbar" role="toolbar" aria-label="Formato del mensaje">
      <core-ui-compact-select
        [options]="blockOptions"
        [value]="blockType"
        placeholder="Texto"
        appearance="light"
        panelAppearance="light"
        optionIndicatorPosition="right"
        [disabled]="isReadOnly"
        (valueChange)="applyBlockValue($event)"
      ></core-ui-compact-select>

      <span class="core-ui-message-composer__divider" aria-hidden="true"></span>

      <ng-container *ngFor="let option of toolbarOptions; trackBy: trackToolbarOption">
        <span *ngIf="option.dividerBefore" class="core-ui-message-composer__divider" aria-hidden="true"></span>

        <button
          type="button"
          class="core-ui-message-composer__tool"
          [ngClass]="option.style"
          [class.is-active]="isFormatActive(option.value)"
          [coreUiSimpleTooltip]="option.label"
          [attr.aria-label]="option.label"
          [attr.aria-pressed]="isFormatActive(option.value)"
          [disabled]="isReadOnly"
          (mousedown)="$event.preventDefault()"
          (click)="toggleToolbarOption(option)"
        >
          {{ option.content }}
        </button>
      </ng-container>

      <span class="core-ui-message-composer__spacer"></span>

      <button
        type="button"
        class="core-ui-message-composer__tool danger"
        coreUiSimpleTooltip="Limpiar todo"
        aria-label="Limpiar mensaje y adjuntos"
        [disabled]="isReadOnly || (!value && !attachmentItems.length)"
        (mousedown)="$event.preventDefault()"
        (click)="clearMessage()"
      >
        <core-ui-icon name="icon_delete" size="16"></core-ui-icon>
      </button>
    </div>

    <div
      #editor
      class="core-ui-message-composer__editor"
      [class.is-empty]="showPlaceholder"
      role="textbox"
      aria-multiline="true"
      [attr.aria-label]="label"
      [attr.aria-placeholder]="placeholder"
      [attr.contenteditable]="isReadOnly ? 'false' : 'true'"
      [attr.data-placeholder]="placeholder"
      [style.min-height.px]="minHeight"
      (beforeinput)="handleBeforeInput($event)"
      (input)="handleInput()"
      (focus)="handleFocus()"
      (blur)="handleBlur()"
      (keyup)="refreshFormatState()"
      (mouseup)="refreshFormatState()"
      (paste)="handlePaste($event)"
      (dragover)="$event.preventDefault()"
      (drop)="handleDrop($event)"
    ></div>

    <div *ngIf="attachmentItems.length" class="core-ui-message-composer__attachments">
      <div
        *ngFor="let attachment of attachmentItems; trackBy: trackAttachment"
        class="core-ui-message-composer__attachment"
      >
        <img *ngIf="attachment.previewUrl; else fileAttachment" [src]="attachment.previewUrl" [alt]="attachment.name" />
        <ng-template #fileAttachment>
          <span class="core-ui-message-composer__attachment-file">
            <core-ui-icon [name]="attachmentIconName(attachment.contentType)" size="18"></core-ui-icon>
            <span>{{ attachment.name }}</span>
          </span>
        </ng-template>
        <button
          type="button"
          [attr.aria-label]="'Quitar ' + attachment.name"
          [disabled]="isReadOnly"
          (click)="removeAttachment(attachment.id)"
        >
          <core-ui-icon name="icon_close" size="12"></core-ui-icon>
        </button>
      </div>
    </div>

    <p *ngIf="attachmentError" class="core-ui-message-composer__feedback error">
      {{ attachmentError }}
    </p>

    <p *ngIf="attachmentItems.length && !attachmentsPersisted" class="core-ui-message-composer__feedback">
      Las imágenes son una vista previa y todavía no se guardarán con la plantilla.
    </p>

    <div class="core-ui-message-composer__footer">
      <div class="core-ui-message-composer__footer-actions">
        <input
          #attachmentInput
          type="file"
          [attr.accept]="fileAccept"
          multiple
          hidden
          (change)="selectAttachments($event)"
        />

        <button
          *ngIf="allowAttachments"
          type="button"
          class="core-ui-message-composer__footer-tool"
          [coreUiSimpleTooltip]="attachmentPickerTooltip"
          [attr.aria-label]="attachmentPickerAriaLabel"
          [disabled]="!canAddAttachments"
          (click)="openAttachmentPicker(attachmentInput)"
        >
          <core-ui-icon name="upload" size="17"></core-ui-icon>
        </button>

      </div>

      <span class="core-ui-message-composer__counter" [class.limit]="characterCount >= maxLength">
        {{ characterCount }}/{{ maxLength }}
      </span>
    </div>
  </div>
</div>
